@for (badge of badges; track $index) {
    <div class="badge"
         [tooltip]="badge.tooltip"
         placement="top"
         [ngClass]="badge.cssClass">
        {{ badge.value }}
    </div>
}
